import { connect } from 'react-redux';
import CallbackProfileModal, { MapStateType, DispatchPropsType } from '../organisms/Webhook/CallbackProfileModal';
import { IStateType } from '../../../../store/models/root.interface';
import { closeModal, getIsOpen, getParams } from '../../../../store/modals';
import {
    requestObject
} from '../../../../store/Object';
import { requestObjects, makeSelectObjectsArray, changeOffset, makeSelectPaginationInProgress, changeSearchStr, changeFilters } from '../../../../store/Objects';
import { Instances } from '../../../../constants';

const mapStateToProps = (state: IStateType) => ({
    callbackProfileList: makeSelectObjectsArray(Instances.CallbackProfiles)(state),
    isScollOptionsLoading: makeSelectPaginationInProgress(Instances.CallbackProfiles)(state),
    modalVisibility: getIsOpen(state),
    wabaID: state.wabaId,
    updateCallbackProfileLoading: makeSelectPaginationInProgress(Instances.getWebHokkCallbackProfile)(state),
    params: getParams(state)
});

const mapDispatchToProps = (dispatch: any) => ({
    onLoadCallbackProfile: () => dispatch((requestObjects(Instances.CallbackProfiles, {} ,{ searchTerm:'title' }))),
    onPaginateCallbackProfiles: () => dispatch((changeOffset(Instances.CallbackProfiles))),
    onSearchTextChange: (searchString: string) => dispatch((changeSearchStr(Instances.CallbackProfiles, searchString))),
    onCloseModal: () => dispatch(closeModal()),
    applyFilters: (filters: any) => dispatch(changeFilters(Instances.CallbackProfiles, filters)),
    getConfiguredCallbackProfile: (wabaId: string) =>
	dispatch(
		requestObject(
			Instances.getWebHokkCallbackProfile,
			undefined,
			undefined,
			'GET',
			true,
			true,
			undefined,
			undefined,
			undefined,
			undefined,
			{
				Id: wabaId
			}
		)
	),
    addCallbackProfile: (wabaId: string, data:any, callBack:any) => 
		dispatch(
			requestObject(
				Instances.getWebHokkCallbackProfile,
				undefined,
				undefined,
				'POST',
				true,
				true,
				data,
				callBack,
				undefined,
				undefined,
				{
					Id: wabaId
				}
			)
		),
    updateCallbackProfile: (wabaId: string, data:any, callBack:any) => 
        dispatch(
            requestObject(
                Instances.getWebHokkCallbackProfile,
                undefined,
                undefined,
                'PUT',
                true,
                true,
                data,
                callBack,
				undefined,
				undefined,
				{
					Id: wabaId
				}
            )
        ),
});

export default connect<MapStateType, DispatchPropsType, unknown, IStateType>(
	mapStateToProps,
	mapDispatchToProps
)(CallbackProfileModal);